import Raven from 'raven-js';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

import initProfileMenu from 'widgets/ProfileMenu';
import initAddToCartButton from 'widgets/AddToCart';
import initNotifications from 'widgets/Notifications';
import initFullCartView from 'widgets/FullCartView';
import initDjangoMessages from 'widgets/DjangoMessages';
import initLandingSlider from 'widgets/LandingSlider';
import initQuantitySelect from 'widgets/QuantitySelect';
import setCookie from "components/ViewSelect";

import initVideoLightbox from 'widgets/VideoLightbox';
import initDropdownCart from 'widgets/DropdownCart';
import initFacetGroups from 'widgets/FacetGroups';
import initCatalogueCategoryList from 'widgets/CatalogueCategoryList';
import initCheckoutCheckbox from 'widgets/CheckoutCheckbox';
import toggleDescription from 'widgets/ToggleDescription';
import toggleAttributes from 'widgets/ToggleAttributes';
import initSmoothScroll from 'widgets/SmoothScroll';
import initSearch from 'widgets/Search';
import initFacetCloud from 'widgets/FacetCloud';

import toggleSubmit from 'utils/toggleSubmit';
import initFixedNavBar from 'utils/fixedNavBar';

import {setUser} from 'ducks/user';
import rootReducer from 'reducers';
import createZoovetvaruStore from './configureStore';

const DEBUG = process.env.NODE_ENV !== 'production';

// Install Raven in production envs
if (!DEBUG) {
    Raven.config(DJ_CONST.RAVEN_PUBLIC_DSN).install(); // eslint-disable-line
    // handle rejected promises
    window.addEventListener('unhandledrejection', (evt) => {
        Raven.captureException(evt.reason);
    });
    // If we have authenticated user, pass its data on to Raven
    if (DJ_CONST.user) {
        Raven.setUserContext({
            id: DJ_CONST.user.id,
            email: DJ_CONST.user.email,
            name: DJ_CONST.user.name,
        });
    }
}

if (!DEBUG) {
    Sentry.init({
      dsn: DJ_CONST.RAVEN_PUBLIC_DSN,
      integrations: [new Integrations.BrowserTracing()],
    
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
    });
    // If we have authenticated user, pass its data on to Raven
    if (DJ_CONST.user) {
        Sentry.setUser({
            id: DJ_CONST.user.id,
            email: DJ_CONST.user.email,
            username: DJ_CONST.user.name,
        });
    }
}



const store = createZoovetvaruStore(rootReducer);
store.dispatch(setUser(DJ_CONST.user));

function init() {
    initFacetGroups();
    initCatalogueCategoryList(store);
    initProfileMenu('#profile-user-menu');
    initAddToCartButton('.add-to-basket-form', store);
    initNotifications('#notifications', store);
    initLandingSlider('#landing-slider');
    initQuantitySelect('.basket-form__quantity');
    initVideoLightbox();
    initDropdownCart('#cart-mini-dropdown', store);
    toggleSubmit('reg-submit', 'terms');
    initFullCartView('#full-basket', store);
    initDjangoMessages(DJ_CONST.djangoMessages, store);
    initCheckoutCheckbox('id_billing-use_billing_address_as_shipping', 'shipping-address');
    setCookie();
    initFixedNavBar('.navbar__container');
    toggleDescription('.product-attributes--none');
    toggleAttributes('.product-attributes--attr');
    initSmoothScroll();
    initSearch(".js-search");
    initFacetCloud(".facet-cloud");
}

export {init}; // eslint-disable-line import/prefer-default-export



// WEBPACK FOOTER //
// ./src/main.js